import React from 'react';

import {twx} from '@/utils/tailwindUtils';

interface AutoDeliveryDcxDetailsFooterProps {
    className?: string;
    children?: React.ReactNode;
}

const AutoDeliveryDcxDetailsFooter = ({className, children}: AutoDeliveryDcxDetailsFooterProps) => {
    return (
        <div
            className={twx(
                'flex flex-col gap-4 ml:mt-8 ml:snap-start ml:border-t ml:border-primary-dark-15 ml:pt-4',
                className
            )}
        >
            {children}
        </div>
    );
};

export default AutoDeliveryDcxDetailsFooter;
